import { FunctionComponent } from "react";
import { Controller, FieldValues, Path, useFormContext } from "react-hook-form";
import { CBOmissionType, IFormValues } from "../../types";
import TextField, { StandardTextFieldProps } from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

interface CBFormTextFieldControllerProps extends StandardTextFieldProps {
    idField?: string,
    formName: Path<IFormValues>,
    label: string,
    readOnly: boolean,
    isDisabled?: boolean,

}

const CBFormTextFieldController: FunctionComponent<CBFormTextFieldControllerProps> = ({
    idField,
    formName,
    label,
    readOnly,
    isDisabled = false,
    inputProps, 
    type = "text",
    ...props

}) => {

    const { t } = useTranslation('customerbase');
    //const {control} = useFormContext<IFormValues>();
    const formContext = useFormContext<IFormValues>();
    
    return (
        <Controller 
            control={formContext.control}
            name={formName}
            render={({field, fieldState}) => (
                <TextField
                    {...field}
                    {...props}
                    fullWidth
                    InputProps={{
                        readOnly: readOnly,
                        autoComplete: 'none'
                    }}
                    inputProps={inputProps}
                    disabled={isDisabled}
                    id={!!idField ? idField : label}
                    label={t(label)}
                    type={type}
                    value={field.value || ''}
                    onBlur={(e) => {
                        field.onBlur();
                        props.onBlur?.(e);

                    }}
                    error={Boolean(fieldState.error)}
                    helperText={fieldState.error?.message}
                />
            )}
        />
    );
}

export default CBFormTextFieldController;